export default class UserRestrictedTo {
  constructor($scope) {
    
    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };


    $scope.init = function() {
      $scope.user = window.user;
    };

    $scope.init();

  }
}

UserRestrictedTo.$inject = ['$scope'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-restricted-to.ctrl.js